async function loadMore(url){
    const newPage = await fetch(url);
    const newPageText = await newPage.text();

    const parser = new DOMParser();
    const newPageDOM = parser.parseFromString(newPageText, 'text/html');

    const nodosNuevos = newPageDOM.querySelectorAll('.product-grid .grid__item');
    console.log('Nodos nuevos:', nodosNuevos)
    const paginationWrapperNuevo = newPageDOM.querySelector('.maje-pagination-wrapper');
    console.log('Paginacion nueva:', paginationWrapperNuevo)
    const collectionGridActual = document.querySelector('.product-grid');
    const paginationWrapperActual = document.querySelector('.maje-pagination-wrapper');

    nodosNuevos.forEach(nodo => {
        collectionGridActual.appendChild(nodo);
    });

    paginationWrapperActual.innerHTML = paginationWrapperNuevo.innerHTML;

    initLoadMore();
    initPLPCards();
    initLoadAll();
    document.dispatchEvent(new CustomEvent("custom:collection:updated", {
        detail: {
            collection: collectionGridActual,
            pagination: paginationWrapperActual
        }
    }));
}

function initLoadMore() {
    const buttonLoadMore = document.querySelector('#load-more-products');
    if(buttonLoadMore == null) return;

    const loadBar = document.querySelector('.cus-load-bar');
    const percentageLoaded = loadBar.querySelector('.cus-load-bar__progress');
    console.log({
        percentage: buttonLoadMore.getAttribute('data-percentage'),
        buttonLoadMore,
        loadBar,
    })

    percentageLoaded.style.width = `${buttonLoadMore.getAttribute('data-percentage')}%`

    const fetchUrl = buttonLoadMore.getAttribute('data-url');
    buttonLoadMore.addEventListener('click', event => {
        console.log('Loading...', fetchUrl);
        loadMore(fetchUrl);
    });
}

async function initLoadAll(){
    const loadAllButton = document.querySelector('#load-all-products');
    if(loadAllButton == null) return;

    const fetchUrl = loadAllButton.getAttribute('data-url');
    const pages = loadAllButton.getAttribute('data-pages');

    loadAllButton.addEventListener('click', async (event) => {
        console.log('Loading All...', fetchUrl);

        for(let i = 2; i <= pages; i++){
            await loadMore(fetchUrl + '&page=' + i);
            console.log(fetchUrl + '&page=' + i)
        }
    });
}

initLoadMore();
initLoadAll();
